import React from 'react';
import { Form } from '../../../types';
import EventFormField from '../../../components/EventFormField/EventFormField';
import { ViewModeDictionary } from '../../../components/EventFormField/EventFormField.types';
import { EventFormViewDetailsWrapper } from './EventFormViewDetailsWrapper';

type EventFormViewDetailsReadOnlyProps = {
  data: Form;
};

export const EventFormViewDetailsReadOnly: React.FC<EventFormViewDetailsReadOnlyProps> = ({ data }) => {
  return (
    <EventFormViewDetailsWrapper>
      {data.fields.map((field) => {
        return (
          <EventFormField
            key={`event-form-field-${field.id}`}
            inputType={field.type}
            label={field.label}
            helper={field.helptext ?? undefined}
            isRequired={field.mandatory}
            mode={ViewModeDictionary.READONLY}
            fieldId={field.id}
            resourceSubType={field.resource_sub_type}
            // TODO: fieldValues needs updated to allow for new value types
            fieldValues={(field.values ?? []) as any}
            multi={field.multi}
          />
        );
      })}
    </EventFormViewDetailsWrapper>
  );
};
